<template>

  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
    >
      <!--  -->

      <v-list>
 
        <v-list-item 
          v-for="(item, index) in exlinks_l" 
          :key="index" 
          exe_atclick="Set_Project(item.action)"
        >

          <v-list-item-title>{{ item.title }}</v-list-item-title>

        </v-list-item>

      </v-list>
    </v-navigation-drawer>
  
    <v-app-bar
      app
      color="whith darken-1"
      flat
    >

    <v-app-bar-nav-icon @click="drawer = !drawer" v-if = btn_drawer></v-app-bar-nav-icon>

    <unidoo-alert></unidoo-alert>

      <v-avatar v-if="false"
        color= 'grey darken-1'
        size="32"
      >{{$run_mode}}</v-avatar>

      {{Project}}

      <v-tabs
        centered
        class="ml-n9"
        color="grey darken-1"
      >
      
        <v-tab
          v-for="link in links_u"
          :key="link.title"
          :to = "link.action"
        >
          {{ link.title }}
        </v-tab>
      </v-tabs>

        <v-row align="baseline" v-if=fale>
          <v-col >

          </v-col>
        <v-col >
          <v-text-field
            v-model="date"
            label="date"
            solo
          ></v-text-field>

          </v-col>
        <v-col >
          <v-text-field
            v-model="time"
            label="time"
            solo
          >
        
      </v-text-field>
           
          </v-col>
                
        </v-row>
        <v-img v-if="telmarche==3" :src="imageSrc_Skyprobe" :key="imageSrc_Skyprobe" @click="dialog_Skyprobe = true" height="51" width="76" class="ma-2" cover />
        <v-dialog
          v-model="dialog_Skyprobe"
          class="dialog-dark"
           
        >


          <v-card class="dialog-dark" elevation="0">
            <CENTER>

            <img
              :src="imageSrc_Skyprobe" :key="imageSrc_Skyprobe"
              style="display:block; max-width:none; max-height:none;"
            />
            </CENTER>
          </v-card>
        </v-dialog>



        <v-img v-if=flase :src="imageSrc_AllSky" :key="imageSrc_AllSky" @click="dialog_AllSky = true"height="51" width="76" class="ma-2" cover />


        <v-dialog
          v-model="dialog_AllSky"

            class="dialog-dark"
        >


          <v-card class="bg-dark" elevation="0">
            <CENTER>

            <v-img
              :src="imageSrc_AllSky" :key="imageSrc_Skyprobe"
              
            />
            </CENTER>
          </v-card>
        </v-dialog>
      <div class="ma-4">{{nuit_l}}</div>

      <v-chip
      v-if="telmarche==3"
        
        color="success"
        outlined
        d-flex
        class="ma-4 d-block mx-auto"
      >On </v-chip>

      <v-chip
        v-if="telmarche==10"
        
        color="error"
        outlined
        d-flex
        class="ma-4 d-block mx-auto"
      >Off </v-chip>

    </v-app-bar>

    

    <v-main class="black dark-3">

      <v-container fluid>
        <v-row>
          <v-col
            :cols= "colSize_g"
            
            v-if = col_g
          >
            <v-sheet
              rounded="lg"
              min-height="60vh"
             
            >
          <br>
            <CENTER><v-chip class="mb-4">{{nuit}}</v-chip></CENTER>
              <v-row>
                <v-col>
                  <v-switch
                    v-model="TU_time"
                    label="TU"
                    v-if="TU_time"
                  ></v-switch>
                  <v-switch
                    v-model="TU_time"
                    label="Heure Locale"
                    v-if="!TU_time"
                  ></v-switch>
                </v-col>
                <v-col>
                  <v-switch
                    v-model="full_liste"
                    label="Toutes"
                    v-if="full_liste"
                  ></v-switch>
                  <v-switch
                    v-model="full_liste"
                    label="A observer"
                    v-if="!full_liste"
                  ></v-switch>
                </v-col>
              </v-row>
                         
              <template>
                <v-data-table
                  :headers="headers_queue"
                  :items="obs_queue"
                  :loading="loading_ot"
                  items-per-page="100"
                  :item-class="getRowClassColor" 
                  hide-default-header
                  hide-default-footer
                  class="elevation-1"
                  @click:row="send_ot"
                >
                  <template v-slot:[`item.the_mission`]="{ item }">

                    N{{item.mission.split("N")[1]}}

                  </template>
                  <template v-slot:[`item.the_start`]="{ item }">
                    <div v-if="TU_time">{{ms_2_time(item.d_start)}} TU</div>
                    <div v-if="!TU_time">{{ms_2_time(item.d_start)}}</div>
                     
                    <v-icon 
                        small
                        
                        color="warning"
                        v-if="item.sheduledstart"
                        >mdi-alert
                    </v-icon>

                  </template>


                  <template v-slot:[`item.fp`]="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-if="item.vis_fabryperot"
                          small
                          color="blue"
                          class="ma-2"
                          v-bind="attrs"
                          v-on="on"
                          >FP
                        </v-icon>
                        <v-icon
                          v-if="item.ir_fabryperot"
                          small
                          color="red"
                          class="ma-2"
                          v-bind="attrs"
                          v-on="on"
                          >FP
                        </v-icon>
                      </template>
                    </v-tooltip>
                  </template>

                  <template v-slot:[`item.instrum`]="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-if="item.instrument == 'vis'"
                          small 
                          color="blue"
                          class="ma-2"
                          v-bind="attrs"
                          v-on="on"
                          >NEO
                        </v-icon>

                        <v-icon
                          v-if="item.instrument == 'ir'"
                          small
                          color="red"
                          class="ma-2"
                          v-bind="attrs"
                          v-on="on"
                          >SPIP
                        </v-icon>

                        <v-icon
                          v-if="item.instrument == 'full'"
                          small
                          color="deep-purple"
                          class="ma-2"
                          v-bind="attrs"
                          v-on="on"
                          >VISION
                        </v-icon>
                        
                        
                      </template>
                    </v-tooltip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon v-if="false"
                      @click="see_ot(item)"
                    >
                    mdi-eye-outline
                    </v-icon>
                    <v-icon v-if="false"
                      @click="send_ot(item)"
                    >
                      mdi-send
                    </v-icon>
                    <v-icon>
                      mdi-send
                    </v-icon>
                  </template>

                </v-data-table>
              </template>

            </v-sheet>
            
          </v-col>

          <v-col
            :cols="colSize_c"
            v-if = col_c
          >
            <v-sheet
              min-height="70vh"
              rounded="lg"
            >
              <router-view></router-view>
            </v-sheet>
          </v-col>

          <v-col
            :cols="colSize_d"
            v-if = col_d
          >
            <v-sheet
              rounded="lg"
              min-height="60vh"
              color="black"
            >
            <br>



                <CENTER><v-chip>{{nuit}}</v-chip></CENTER>

                <v-timeline>

                  <v-timeline-item
                    v-for="pn of this.CDN"
                    :key="pn.id"
                    fill-dot
                    class="white--text mb-2"
                    color="blue darken+2"
                    medium
                    right
                    v-bind="attrs"
                    v-on="on"
                    @click.native.stop="See_OT_OBS_DN(pn)"
                  >

                    <template 
                      v-slot:icon
                    >
                      <span>DN</span>
                    </template>

                    {{pn.modeobservatoire}}

                  </v-timeline-item>
                  <v-timeline-item
                    v-for="pn of this.OBS"
                    :key="pn.id"
                    color="blue darken+2"
                    right
                    large

                    @click.native.stop="See_OT_OBS_OBS(pn)"
                  >
                    <template 
                      v-slot:icon
                    >

                      <span>{{recap_pose(pn)}}</span>


                    </template>
                    <span slot="opposite"><center>{{pn.og_name}} <br> {{pn.nummiss}}</center></span>
                    <div v-if="pn.statut=='RUN'"><strong class="red--text text--lighten-1">{{pn.data_pose}}</strong></div>
                    <div v-else>{{pn.data_pose}}</div>      

                  </v-timeline-item>

                  <v-timeline-item
                    v-for="pn of this.CFN"
                    :key="pn.id"
                    fill-dot
                    class="white--text mb-2"
                    color="blue darken+2"
                    large
                    right
                    @click.native.stop="See_OT_OBS_FN(pn)"
                  >
                    <template v-slot:icon>
                      <span>FN</span>
                    </template>

                    {{pn.modeobservatoire}}

                  </v-timeline-item>

                </v-timeline>        

        


            </v-sheet>
          </v-col>
          
        </v-row>
      </v-container>
    </v-main>
  </v-app>

</template>

<script>

import { ref } from 'vue'

  export default {
    initialize(){

    },
    created(){

    },
    beforeMount(){
      

    },


    destroyed: function() {
      //clearInterval(this.A_Update_tel);
      //clearInterval(this.A_Update_Night);
      //clearInterval(this.A_Update_info);
      
    },
    data: () => ({
      
      dialog_Skyprobe : false,
      dialog_AllSky : false,

      telmarche : 0,
      imageSrc_Skyprobe : "http://wwwtbl3.pic.obs-mip.fr/Skyprobe/img/2025-11-20/Skyprobe_2025-11-20_16-22-07.webp",
      imageSrc_AllSky : "https://supervision.pic.obs-mip.fr:3000/public/img/allsky_latest.jpg?nocache=${Date.now()}",
      
      
      btn_drawer : true,
      drawer : false,
      Project : "Pipo",

      t_col_g : "0",
      col_g : false,
      t_col_c : "12",
      col_c : true, 
      t_col_d : "0",
      col_d : false,

      
      TU_time : true,
      full_liste : true,
      loading_ot : false,

      tel:{
        "timestamp":"2073-04-01T00:00:00.000Z",
        "st":"12h00m00s",
        "ah":"+6h00m00s",
        "ra":0.0,
        "dec":0.0,
        "airmass":0,
        "telmarche":0,
        "date":"2073-04-01",
        "time":"00:00:00"
      },
      lastpos: {},

      A_Update_tel : null,
      A_Update_Night : null,
      A_Update_inf : null,
      save :        { text: '', value: 'mission'},

      headers_queue:[
        { text: '', value: 'the_start'},
        { text: '', value: 'instrum' },
        { text: 'OTs', value: 'name' },
        { text: 'mission', value: 'the_mission'},
        { text: '', value: 'fp'},
        { text: 'Actions', value: 'actions'}
      ],
      headers_queue_out:[
        { text: 'Targets', value: 'objet' },
      ],
      obs_queue:[],
      headers: {
        queue : [

        ]
      },
      obs:{
        queue_full:[],
        queue:[],
        run:[],
        done:[],
        encours:{}
      },
      prenuit:[{"name":"test"}],

      links_u: [



      ],

      Projects : {
        TBL_ETCs : [
          {title:'Full Spectrum',action:'/ETC/VISION'},
          {title:'Visible Spectrum',action:'/ETC/NEONARVAL'},
          {title:'Infrared Spectrum',action:'/ETC/SPIP'},

        ],
        Observations : [
          {title:'ENCOURS',action:'/'},
          {title:'NEO-NARVAL',action:'/NEO-NARVAL'},
          {title:'DRS',action:'/DRS'},
          {title:'SPIP',action:'/SPIP'},
          {title:'Pilote',action:'/PILOTE'},
          {title:'SKYPROBE',action:'/SKYPROBE'},
          {title:'JOURNALISATION',action:'/JOURNALISATION'},
        ],
        NUIT : [
          {title:'ENCOURS',action:'/NUIT/ENCOURS'},
          {title:'NEO',action:'/NUIT/NEO'},
          {title:'SKYPROBE',action:'/NUIT/SKYPROBE'},
        ],
        DRS : [

        ],
        DATA : [
          {title:'DMP NEO-NARVAL',action:'/DATA/DMP_NEO-NARVAL'},
          {title:'DMP NARVAL',action:'/DATA/DMP_NARVAL'},
          {title:'DMP SPIP',action:'/DATA/DMP_SPIP'},
          {title:'Volumes',action:'/DATA/VOLUMES'},
        ],
        GTC : [
          {title:'Nodes',action:'/GTC'},
          {title:'Taches',action:'/GTC/TACHES'},
        ],
        Diagnostique : [
          {title:'CRITICITE',action:'/DIAGNOSTIQUE/CRITICITE'},
        
        ],

        SSS : [

        ],        
        NEO_NARVAL : [
          {title:'ACQ_NEO_FILES',action:'/NEO_NARVAL/ACQ_FILES'},
          {title:'NUIT',action:'/NEO-NARVAL/NUIT'},
          {title:'NEO-NARVAL',action:'/NEO-NARVAL'},
          {title:'Calibrations'},
          {title:'Observations',action:'/NEO-NARVAL/OBSERVATIONS'}
        ],        
        SPIP : [
          {title:'SPIP',action:'/SPIP'},
        ],
        VISION : [
          {title:'VISION',action:'/VISION'} 
        ],
        Journalisation : [
          
          {title:'Objets',action:'/JOURNALISATION/OBJETS'},
          {title:'Dates',action:'/JOURNALISATION/DATES'},
          {title:'JOURNALISATION',action:'/JOURNALISATION'}, 
        ],
        Skyprobe : [
            {title:'Live',action:'/'},
            {title:'Nuit',action:'/Nuit'},
            {title:'Objet',action:'/Objet'},
            {title:'Statistiques',action:'/Stats'},
            {title:'Données',action:'/Datas'},
        ],
        Telescope : [
          {title:'Pointe',action:'/Pointing'},
          {title:'Pointe2',action:'/Pointing2'},
          {title:'Pilote',action:'/Pilote'},

        ]

      },





      links_l : [
        {title:'TBL-ETCs',action:'TBL_ETCs'},  
        {title:'Skyprobe',action: 'Skyprobe'},
        {title:'Télescope',action: 'Telescope'}
      ],
    links_l_ph3 : [
        {title:'Observations', action: 'Observations'},
        {title:'NUIT',action: 'NUIT'},
        {title:'DRS',action: 'DRS'},
        {title:'DATA',action: 'DATA'},
        {title:'GTC',action: 'GTC'},
        {title:'Diagnostique',action: 'Diagnostique'},
        {title:'Skyprobe',action: 'Skyprobe'},
        {title:'SSS',action: 'SSS'},
        {title:'NEO_NARVAL',action: 'NEO_NARVAL'},
        {title:'VISION',action: 'VISION'},
        {title:'Journalisation',action: 'Journalisation'},
      ],
      colSize_d: "0",
      colSize_c: "0",
      colSize_g: "0",
      col_d : true,
      col_c : true,
      col_g : true,

      

      A_lastpos: null,
      info:{
          nuit:"",
          nuit_l:"",
          neo_nuit:""

      },

      ots:[],
      nights:[],

      nuit:"",



      date : "",
      time : "00:00:00",


      nuit : "0001-01-01",
      nuit_l : "", 

   

      message:" ",

      run : false,

    }),

    methods: {
      Set_Project(project){
        this.Project = project;
        this.links_u = this.Projects[project];
        this.drawer = false;
        switch (project) {

          case "Observations":

            
          this.$router.push('/');


            this.colSize_g = 3;
            this.colSize_c = 6;
            this.colSize_d = 3;
            this.col_g = true;
            this.col_c = true;  
            this.col_d = true; 
            break;

          case "DATA":
          case "NUIT":
          case "Diagnostique":
         case "TBL_ETCs":
            this.$router.push('/');

            this.colSize_c = 12;
            this.col_g = false;  
            this.col_c = true;  
            this.col_d = false; 
            break;
          case "Skyprobe":
            this.$router.push('/');

            this.colSize_c = 12;
            this.col_g = false;  
            this.col_c = true;  
            this.col_d = false; 
            break;
          case "Telescope":
            this.$router.push('/Telescope');

            this.colSize_c = 12;
            this.col_g = false;  
            this.col_c = true;  
            this.col_d = false; 
            break;
          
          case "SSS":
          case "NEO_NARVAL":  
          case "DRS":
          case "VISION":
          case "Journalisation":

            this.$router.push('/JOURNALISATION');
            this.colSize_c = 12;
            this.col_g = false;  
            this.col_c = true;  
            this.col_d = false; 
            break;
          
          case 'GTC':

            this.$router.push('/GTC');
            this.colSize_c = 12;
            this.col_g = false;  
            this.col_c = true;  
            this.col_d = false; 
            break;
        }


        
      },
      ms_2_time(ms){
        var retour;
        const date = new Date((ms * 1));//+(3600*2000));
        if(this.TU_time){
          retour = date.toLocaleTimeString([], {timeZone: "UTC", hour: '2-digit', minute: '2-digit'}); //date.toDateString();
        }else{
          retour = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit'}); //date.toDateString();
        }
//        const retour = date.toLocaleTimeString('en-US');
        return retour;


        //[]
        //return date.toLocaleTimeString('en-US');
      },
      See_OT_OBS_DN(pn){
        alert(pn.id);
      },
      See_OT_OBS_OBS(pn){
        alert(pn.id);
      },
      See_OT_OBS_FN(pn){
        alert(pn.id);
      },
      see_ot(item){
      },
      send_ot(item){

        this.loading_ot = true;
        item.createloading = true; 
        
        const othis=this;
        
        var url = "";
        url = backend_url + "/Ph3/Nuit/ot2neo/"+item.id;

        this.axios.post(url)
        .then((res) => {

          //console.log(res);
          othis.loading_ot = false;
          
        })
        .catch((error) => {
          othis.loading_ot = false;
          console.error(error);
          console.log("PB get_Night");

        });
      },

      getRowClassColor(item) {
        var  color= "pgrey darken-3";
        switch(item.ot_color_state){
          case "COLOR_QUEU":
            color = "black";
            break;

          case "COLOR_OBS":
          color = "red accent-3";
          break;
          case "COLOR_PRET":

              color = "green darken-1";
          default:
        }
        return color;
      } 

    },
    computed: {
      formattedTime() {
        return this.currentTime.toLocaleTimeString('fr-FR', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        });
      },
    },
    mounted: function() {

      this.Set_Project("TBL_ETCs");

    },
    updated: function(){
    }
  }
  
  
</script>
